import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { Card, ModernCardHeader } from "../../../components/cards";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { useOrders } from "../../orders/hooks";

export const RecentOrdersWidget: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useOrders({ where: {} });

  const orders = [...(data?.orders?.results ?? [])]
    .sort((a, b) => b.id - a.id)
    .slice(0, 5);

  return (
    <Card>
      <ModernCardHeader
        title="Dernières commandes"
        subtitle="Commandes récemment créées"
        action={
          <span
            className="text-xs text-indigo-600 cursor-pointer hover:underline"
            onClick={() => navigate("/orders")}
          >
            Voir tout
          </span>
        }
      />
      {loading ? (
        <Loading />
      ) : !orders.length ? (
        <EmptyList text="Aucune commande" />
      ) : (
        <div className="space-y-1 mt-3">
          {orders.map((order) => (
            <div
              key={`recent-order-${order.id}`}
              className="flex items-center justify-between gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer border border-transparent hover:border-gray-200"
              onClick={() => navigate(`/order/${order.id}`)}
            >
              <div className="flex items-center gap-2 min-w-0">
                <div className="bg-indigo-50 text-indigo-600 p-1.5 rounded-md flex-shrink-0">
                  <ShoppingCart className="w-4 h-4" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm text-gray-900 truncate">
                    {order.number ?? `#${order.id}`}
                  </p>
                  <p className="text-xs text-gray-500 truncate">{order.customer?.name}</p>
                </div>
              </div>
              <span className="text-xs font-semibold text-gray-700 whitespace-nowrap">
                {((order.totalTtcCents ?? 0) / 100).toFixed(2)} €
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
